import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ModalPopUpService {
    private tableTemplate: object[];
    private tableConfigs: object;
    private filterConfig: object;
    private requestMethodName: string;
    private workFlowName: string;
    private filterMethodName: string;
    private constructSource: any;
    private compScope: any;

    setControlConfigs(tableOptions, formConfigOptions, workFlowName, scope, constructSource) {
        this.tableTemplate = tableOptions.template;
        this.tableConfigs  = tableOptions.configs;

        this.filterConfig = formConfigOptions && formConfigOptions.configs ? formConfigOptions.configs : '';
        
        this.workFlowName      = workFlowName;
        this.requestMethodName = tableOptions.requestMethodName;
        this.filterMethodName = formConfigOptions && formConfigOptions.filterMethodName ? formConfigOptions.filterMethodName : '';
        
        this.compScope = scope;
        this.constructSource = constructSource;
    }

    getControlConfigs() {
        return {
            tableTemplate    : this.tableTemplate,
            tableConfigs     : this.tableConfigs,
            filterConfig     : this.filterConfig,
            workFlowName     : this.workFlowName,
            requestMethodName: this.requestMethodName,
            filterMethodName : this.filterMethodName,
            constructSource  : this.constructSource,
            compScope        : this.compScope
        }
    }
}